
<mat-dialog-content class="mat-badge-medium">
    <button class="close" mat-button title="Cancel" mat-dialog-close><i class="material-icons clear">clear</i></button>
    <div mat-dialog-title>Refresh of Scheduled Rebalance Information</div>
    <p>Scheduled rebalance information is displayed as of start of day.
    You can refresh this information intraday, but this may take a few minutes, during which time iRebal won't be available.</p>
    <mat-dialog-actions>
        <button id="closeButton" mat-dialog-close class="btn-medium-secondary">Do not refresh</button>
        <button id="refreshButton" mat-dialog-close class="btn-medium-primary" (click)="refreshSchdRebalance()">Refresh</button>
    </mat-dialog-actions>
</mat-dialog-content>